<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Configuração de Alertas'">
          <template v-slot:preview>
            <v-row v-if="enviandoEmails" class="mb-5">
              <span class="indigo--text"
                >Enviando E-mails. Aguarde, por favor ...</span
              >
              <v-progress-linear
                indeterminate
                color="indigo"
              ></v-progress-linear>
            </v-row>
            <v-row
              justify="end"
              v-if="
                !enviandoEmails &&
                (configsBaixa.length > 0 ||
                  configsMedia.length > 0 ||
                  configsAlta.length > 0)
              "
            >
              <v-btn type="button" color="info" @click="enviarEmails()"
                ><v-icon class="mr-2" small>fas fa-bell</v-icon>Enviar Alertas
                Manualmente</v-btn
              >
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  :items="departamentos"
                  label="Selecione um Departamento"
                  item-text="caminhoCompleto"
                  item-value="id"
                  v-model="alertaConfig.departamentoID"
                  @change="listaConfiguracoes()"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="alertaConfig.departamentoID">
              <v-col cols="12">
                <v-select
                  v-model="status"
                  label="Status Documento"
                  :items="statusEnum"
                  item-value="id"
                  item-text="name"
                  multiple
                  chips
                  clearable
                />
              </v-col>
              <v-col cols="4">
                <div class="card">
                  <div class="card-header success text-light">
                    Baixa Criticidade
                  </div>
                  <div class="card-body">
                    <!-- <form
                      class="row"
                      v-on:submit.prevent="
                        salvarPeriodicidade(1, periodicidadeBaixa)
                      "
                    > -->
                    <div class="col-6">
                      <v-text-field
                        label="Periodicidade envio alerta"
                        required
                        type="number"
                        prefix="A cada "
                        suffix="Dia(s)"
                        v-model="periodicidadeBaixa"
                      ></v-text-field>
                    </div>
                    <!-- <div class="col-2 pt-5">
                        <v-btn type="submit" color="blue" fab x-small dark
                          ><v-icon>fas fa-save</v-icon></v-btn
                        > -->
                    <!-- </div> -->
                    <!-- </form> -->
                    <form class="row" v-on:submit.prevent="salvarEmail(1)">
                      <div class="col-10">
                        <v-text-field
                          label="E-mail"
                          clearable
                          required
                          v-model="emailBaixa"
                        ></v-text-field>
                      </div>
                      <div class="col-2 pt-5">
                        <v-btn
                          type="submit"
                          color="success"
                          fab
                          x-small
                          dark
                          :disabled="loading || !verificarPermissao(1)"
                          ><v-icon>fas fa-save</v-icon></v-btn
                        >
                      </div>
                    </form>
                    <hr />
                    <v-alert
                      outlined
                      type="success"
                      v-if="configsBaixa.length === 0"
                      >Não há nenhum email vinculado ainda</v-alert
                    >
                    <table class="table" v-else>
                      <thead>
                        <tr>
                          <th>Email Cadastrados</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(config, index) in configsBaixa"
                          :key="config.id"
                        >
                          <td class="pt-5">
                            <strong>{{ index + 1 }}.</strong> {{ config.email }}
                          </td>
                          <td align="center" style="width: 20%">
                            <v-btn
                              color="error"
                              icon
                              :disabled="!verificarPermissao(3)"
                              @click="excluir(config.id)"
                              ><v-icon small>fas fa-trash</v-icon></v-btn
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="card">
                  <div class="card-header warning text-light">
                    Média Criticidade
                  </div>
                  <div class="card-body">
                    <!-- <form
                      class="row"
                      v-on:submit.prevent="
                        salvarPeriodicidade(2, periodicidadeMedia)
                      "
                    > -->
                    <div class="col-6">
                      <v-text-field
                        label="Periodicidade envio alerta"
                        required
                        type="number"
                        prefix="A cada "
                        suffix="Dia(s)"
                        v-model="periodicidadeMedia"
                      ></v-text-field>
                    </div>
                    <!-- <div class="col-2 pt-5">
                        <v-btn type="submit" color="blue" fab x-small dark
                          ><v-icon>fas fa-save</v-icon></v-btn
                        >
                      </div>
                    </form> -->
                    <form class="row" v-on:submit.prevent="salvarEmail(2)">
                      <div class="col-10">
                        <v-text-field
                          label="E-mail"
                          clearable
                          required
                          v-model="emailMedia"
                        ></v-text-field>
                      </div>
                      <div class="col-2 pt-5">
                        <v-btn
                          type="submit"
                          color="warning"
                          fab
                          x-small
                          dark
                          :disabled="loading || !verificarPermissao(1)"
                          ><v-icon>fas fa-save</v-icon></v-btn
                        >
                      </div>
                    </form>
                    <hr />
                    <v-alert
                      outlined
                      type="warning"
                      v-if="configsMedia.length === 0"
                      >Não há nenhum email vinculado ainda</v-alert
                    >
                    <table class="table" v-else>
                      <thead>
                        <tr>
                          <th>Email Cadastrados</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(config, index) in configsMedia"
                          :key="config.id"
                        >
                          <td class="pt-5">
                            <strong>{{ index + 1 }}.</strong> {{ config.email }}
                          </td>
                          <td align="center" style="width: 20%">
                            <v-btn
                              color="error"
                              icon
                              @click="excluir(config.id)"
                              :disabled="!verificarPermissao(3)"
                              ><v-icon small>fas fa-trash</v-icon></v-btn
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="card">
                  <div class="card-header error text-light">
                    Alta Criticidade
                  </div>
                  <div class="card-body">
                    <!-- <form
                      class="row"
                      v-on:submit.prevent="
                        salvarPeriodicidade(3, periodicidadeAlta)
                      "
                    > -->
                    <div class="col-6">
                      <v-text-field
                        label="Periodicidade envio alerta"
                        required
                        type="number"
                        prefix="A cada "
                        suffix="Dia(s)"
                        v-model="periodicidadeAlta"
                      ></v-text-field>
                    </div>
                    <!-- <div class="col-2 pt-5">
                        <v-btn type="submit" color="blue" fab x-small dark
                          ><v-icon>fas fa-save</v-icon></v-btn
                        >
                      </div>
                    </form> -->
                    <form class="row" v-on:submit.prevent="salvarEmail(3)">
                      <div class="col-10">
                        <v-text-field
                          label="E-mail"
                          clearable
                          required
                          v-model="emailAlta"
                        ></v-text-field>
                      </div>
                      <div class="col-2 pt-5">
                        <v-btn
                          type="submit"
                          color="error"
                          fab
                          x-small
                          dark
                          :disabled="loading || !verificarPermissao(1)"
                          ><v-icon>fas fa-save</v-icon></v-btn
                        >
                      </div>
                    </form>
                    <hr />
                    <v-alert
                      outlined
                      type="error"
                      v-if="configsAlta.length === 0"
                      >Não há nenhum email vinculado ainda</v-alert
                    >
                    <table class="table" v-else>
                      <thead>
                        <tr>
                          <th>Email Cadastrados</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(config, index) in configsAlta"
                          :key="config.id"
                        >
                          <td class="pt-5">
                            <strong>{{ index + 1 }}.</strong> {{ config.email }}
                          </td>
                          <td align="center" style="width: 20%">
                            <v-btn
                              color="error"
                              icon
                              :disabled="!verificarPermissao(3)"
                              @click="excluir(config.id)"
                              ><v-icon small>fas fa-trash</v-icon></v-btn
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="4">
                <v-btn @click="save" color="primary" :disabled="loading"
                  >Salvar</v-btn
                >
              </v-col>
            </v-row>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <TelaLoading :overlay="loading"></TelaLoading>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  name: "configuracoesAlerta",
  data() {
    return {
      enviandoEmails: false,
      loading: false,
      departamentos: [],
      configsBaixa: [],
      configsMedia: [],
      configsAlta: [],
      cliente: {},
      alertaConfig: {
        departamentoID: 0,
        criticidadeAlertaID: 0,
        email: "",
      },
      emailBaixa: "",
      emailMedia: "",
      emailAlta: "",
      periodicidadeBaixa: 1,
      periodicidadeMedia: 1,
      periodicidadeAlta: 1,
      statusEnum: [
        { id: 0, name: "Reprovado" },
        { id: 1, name: "Aprovado" },
        { id: 2, name: "Aguardando Arquivos" },
        { id: 3, name: "Aguardando Validação" },
      ],
      status: [],
    };
  },
  components: {
    KTCodePreview,
    TelaLoading,
  },
  methods: {
    listaDepartamentos() {
      return new Promise((resolve) => {
        ApiService.get("departamento/getByClienteID/" + this.cliente.id).then(
          ({ data }) => {
            resolve(data);

            if (data.success) this.departamentos = data.data;
            else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
    },

    async listaConfiguracoes() {
      this.loading = true;
      const { data: result } = await ApiService.get(
        "alertaConfig/getByDepartamentoID/" + this.alertaConfig.departamentoID
      );
      if (result.success) {
        this.configsBaixa = result.data.filter((x) => {
          return x.criticidadeAlertaID === 1;
        });
        this.configsMedia = result.data.filter((x) => {
          return x.criticidadeAlertaID === 2;
        });
        this.configsAlta = result.data.filter((x) => {
          return x.criticidadeAlertaID === 3;
        });

        await this.getPeriodicidades();
        await this.getStatus();
        this.loading = false;
      } else SweetAlert.sweetAlertError(result.errors);
    },

    salvarEmail(criticidadeAlertaID) {
      let self = this;
      this.loading = true;
      this.alertaConfig.criticidadeAlertaID = criticidadeAlertaID;

      switch (criticidadeAlertaID) {
        case 1:
          this.alertaConfig.email = this.emailBaixa.trim();
          break;
        case 2:
          this.alertaConfig.email = this.emailMedia.trim();
          break;
        case 3:
          this.alertaConfig.email = this.emailAlta.trim();
          break;
      }

      return new Promise((resolve) => {
        ApiService.post("alertaConfig", this.alertaConfig).then(({ data }) => {
          resolve(data);

          if (data.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Email Vinculado com Sucesso!",
              showConfirmButton: false,
              timer: 1500,
            }).then(function () {
              self.alertaConfig.criticidadeAlertaID = 0;
              self.alertaConfig.email = "";

              self.emailBaixa = "";
              self.emailMedia = "";
              self.emailAlta = "";

              self.listaConfiguracoes();
            });
          } else SweetAlert.sweetAlertError(data.errors);
        });
      }).finally(() => (this.loading = false));
    },

    excluir(id) {
      let self = this;
      return new Promise((resolve) => {
        ApiService.delete("alertaConfig/" + id).then(({ data }) => {
          resolve(data);

          if (data.success) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Email Removido com Sucesso!",
              showConfirmButton: false,
              timer: 1500,
            }).then(function () {
              self.listaConfiguracoes();
            });
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    async enviarEmails() {
      let self = this;

      this.enviandoEmails = true;

      const { data: ret } = await ApiService.get(
        "registro/enviar-email-pendencias/" + this.alertaConfig.departamentoID
      );

      if (ret.success === true) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Alertas Enviados com Sucesso!",
          showConfirmButton: false,
          timer: 1500,
        }).then(function () {
          self.enviandoEmails = false;
        });
      } else SweetAlert.sweetAlertError(ret.erros);
    },
    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Alerta, permissao);
    },

    async salvarPeriodicidade(criticidade, periodicidade) {
      // this.loading = true;
      const p = {
        departamentoID: this.alertaConfig.departamentoID,
        criticidadeID: criticidade,
        intervaloDias: periodicidade,
      };

      return new Promise(async (resolve) => {
        await ApiService.post("AlertaConfig/Periodicidade", p).then(
          ({ data }) => {
            resolve(data);

            if (data.success) {
              // Swal.fire({
              //   position: "center",
              //   icon: "success",
              //   title: "Periodicidade salva com Sucesso!",
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
            } else SweetAlert.sweetAlertError(data.errors);
          }
        );
      });
      // .finally(() => (this.loading = false));
    },
    async getPeriodicidades() {
      const { data: result } = await ApiService.get(
        `AlertaConfig/Periodicidades/${this.alertaConfig.departamentoID}`
      );
      if (result.success) {
        this.periodicidadeBaixa =
          result.data.find((d) => d.criticidadeID === 1)?.intervaloDias ?? 1;
        this.periodicidadeMedia =
          result.data.find((d) => d.criticidadeID === 2)?.intervaloDias ?? 1;
        this.periodicidadeAlta =
          result.data.find((d) => d.criticidadeID === 3)?.intervaloDias ?? 1;
      }
    },
    async getStatus() {
      const { data: result } = await ApiService.get(
        `AlertaConfig/ConfigStatus/${this.alertaConfig.departamentoID}`
      );

      if (result.success && result.data) {
        this.status = result.data.status;
      }
    },

    async save() {
      this.loading = true;
      await this.salvarPeriodicidade(1, this.periodicidadeBaixa);
      await this.salvarPeriodicidade(2, this.periodicidadeMedia);
      await this.salvarPeriodicidade(3, this.periodicidadeAlta);
      await ApiService.post("AlertaConfig/ConfigStatus", {
        departamentoId: this.alertaConfig.departamentoID,
        status: this.status,
      }).then(({ data }) => {
        if (data.success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Dados salvos com sucesso!",
            showConfirmButton: false,
            timer: 1500,
          });
        } else SweetAlert.sweetAlertError(data.errors);
      }).finally(() => this.loading = false);
    },
  },
  mounted() {
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.listaDepartamentos();
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(Modulo.Alerta, Permissoes.Visualizar)
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
